import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Input,
  DatePicker,
  Checkbox,
  Radio,
  Spin,
  Upload,
  Button,
  message,
  Switch,
  Mentions,
} from "antd";
import { AutoComplete } from "antd";
import dayjs from "dayjs";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { CustomTagsEnum } from "../../../src/Common/constant";
import Dragger from "antd/lib/upload/Dragger";
import { ButtonFilled, Buttontransparent } from "../UIButtons";
import EditorConvertToHTML from "../EditorConvertToHTML";
import EditorWithMentions from "../EditorWithMentions";
import { EmailTagInput } from "../../EmailTagInput";

const { RangePicker } = DatePicker;

const textEnd = {
  textAlign: "end",
};

function UIElement({
  label,
  type,
  options,
  name,
  position,
  background,
  textColor,
  disabled,
  row,
  Placeholder,
  maxLength,
  handleChange,
  value,
  content,
  readOnly,
  loading,
  event,
  handleClick,
  handleBack,
  validationRules,
  handleForgotPassword,
  onKeyDown,
  suffixUrl,
  domainStatus,
  urlLoader,
  link,
  form,
  handleSelectChange,
  picker,
  buttons,
  uploadFile,
  handleNxt,
  viewOnly = false,
  mode,
  format = "DD-MM-YYYY",
  showtime = false,
  customFields,
  selectedCountry,
  countryCode,
  mobileValue,
  locationClick = () => {},
  initialValues = {},
  onFenceCreate,
  onFenceEdit,
  isFenceEditMode = false,
  fenceLookupLoading = false,
}) {
  const labelCol = { span: 24 }; // Label takes full width
  const wrapperCol = { span: 24 }; // Input takes full width

  // const countryOptions = countryList.map((country) => ({
  //   label: country,
  //   value: country,
  // }));
  const [remainingFiles, setRemainingFiles] = useState(
    5 - form.getFieldValue(name)?.length,
  );
  const tagSuggestions = CustomTagsEnum?.map((tag) => ({
    text: tag?.label,
    value: tag?.value,
  }));

  const generateUniqueId = () => {
    // Generate a random number and convert it to base 36 (numbers + letters)
    const randomNumber = Math.random().toString(36).substr(2, 9);

    // Get the current timestamp
    const timestamp = Date.now();

    // Combine the random number with the timestamp
    const uniqueId = randomNumber + timestamp;

    return uniqueId;
  };

  const btnStyle = {
    background: background,
    minWidth: "100px",
    "@media only screen and (max-width: 376px)": {
      minWidth: "120px",
    },
  };

  const divStyle = {
    background: background,
    color: textColor,
  };
  const pickerstyle = { width: "100%" };
  const labelsize = { fontSize: "14px" };

  const stepBtnStyle = {
    background: "#E3E8FC",
    // color: `${COLORS.TEXT.PRIMARY}`,
  };
  return (
    <div>
      {type === "label" && <h6>{label}</h6>}
      {readOnly && (
        <Form.Item label={label}>
          {value ? <strong>{value}</strong> : <Spin />}
        </Form.Item>
      )}
      {type === "select" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Select
            placeholder={Placeholder}
            mode={mode}
            options={options?.map((item) => ({
              value: item,
              label: item,
            }))}
            showSearch={true}
            value={value}
            disabled={disabled}
            onChange={(e) => handleSelectChange(e, name)}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          />
        </Form.Item>
      )}

      {type === "selectwithvalueandcheckbox" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Select
            className="w-100"
            placeholder={Placeholder}
            options={options?.map((item) => ({
              value: item.value,
              label: item.label,
            }))}
            allowClear
            disabled={disabled}
            showSearch={true}
            mode="multiple"
            maxTagCount="responsive"
            value={value}
            onChange={(e) => handleSelectChange(e, name)}
            menuItemSelectedIcon={null}
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            optionRender={(option) => {
              const checked = value?.includes(option.value);
              return (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox checked={checked} style={{ marginRight: 8 }} />
                  {option.label}
                </div>
              );
            }}
          />
        </Form.Item>
      )}

      {type === "selectwithvalue" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Select
            className="w-100"
            placeholder={Placeholder}
            options={options?.map((item) => ({
              value: item.value,
              label: item.label,
            }))}
            allowClear
            disabled={disabled}
            showSearch={true}
            mode={mode}
            value={value}
            onChange={(e) => handleSelectChange(e, name)}
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            listHeight={200}
          />
        </Form.Item>
      )}

      {type === "textorselect" && !readOnly && (
        <Form.Item
          label={label}
          name={name}
          rules={validationRules}
          colon={false}
          labelCol={{ span: 24 }} // full width label on its own row
          wrapperCol={{ span: 24 }} // full width input below it
        >
          <AutoComplete
            className="w-100"
            placeholder={Placeholder}
            options={options?.map((item) => ({
              value: item.label,
            }))}
            disabled={disabled}
            filterOption={(inputValue, option) =>
              option?.value?.toLowerCase().includes(inputValue.toLowerCase())
            }
            value={value}
            onChange={(val) => handleSelectChange(val, name)}
          >
            <Input />{" "}
            {/* Remove all inline styles — let AutoComplete handle it */}
          </AutoComplete>
        </Form.Item>
      )}

      {type === "selectwithvalueAutocomplete" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <AutoComplete
            className="w-100"
            placeholder={Placeholder}
            options={options?.map((item) => ({
              value: item.value,
              label: item.label,
            }))}
            allowClear
            disabled={disabled}
            value={value}
            onChange={(val) => handleSelectChange(val, name)}
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
            dropdownMatchSelectWidth={false}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          />
        </Form.Item>
      )}

      {(type === "text" || type === "email" || type === "number") &&
        !readOnly && (
          <Form.Item
            label={label}
            labelCol={labelCol}
            wrapperCol={wrapperCol}
            name={name}
            rules={validationRules}
          >
            <Input
              disabled={disabled}
              placeholder={Placeholder}
              type={type}
              name={name}
              maxLength={maxLength}
              onChange={handleChange}
              readOnly={viewOnly}
              value={value}
              onKeyDown={(e) => {
                const value = onKeyDown?.test(e.key);
                if (!value && e.key !== "Backspace" && onKeyDown) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
        )}
      {type === "file" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
          valuePropName="fileList" // for Ant Design Upload compatibility
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) return e;
            return e?.fileList.map((f) => f.originFileObj);
          }}
        >
          <Upload
            multiple
            listType="text"
            beforeUpload={(file) => {
              const isValidFile =
                file.type === "application/pdf" ||
                file.type.startsWith("image/");
              if (!isValidFile) {
                message.error("Only PDF and image files are allowed.");
                return Upload.LIST_IGNORE;
              }
              return false; // Prevent auto upload
            }}
            onChange={(info) => {
              const fileList = info.fileList.map((file) => file.originFileObj);
              handleChange({ target: { name, value: fileList } });
            }}
            onPreview={async (file) => {
              let src = file.url;
              if (!src && file.originFileObj) {
                src = await new Promise((resolve) => {
                  const reader = new FileReader();
                  reader.readAsDataURL(file.originFileObj);
                  reader.onload = () => resolve(reader.result);
                });
              }

              const img = new Image();
              img.src = src;
              const w = window.open(src);
              w?.document.write(img.outerHTML);
            }}
            itemRender={(originNode, file, fileList, actions) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "8px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      maxWidth: "150px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {file.name}
                  </span>
                  <Button
                    type="text"
                    danger
                    onClick={actions.remove}
                    size="small"
                  >
                    Delete
                  </Button>
                </div>
              );
            }}
          >
            <Buttontransparent size="large">Add File</Buttontransparent>
          </Upload>
        </Form.Item>
      )}
      {type === "mentions" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Mentions
            placeholder={Placeholder}
            value={value}
            onChange={(val) => handleChange(val, "message")}
            prefix={["@"]}
            options={CustomTagsEnum.map((tag) => ({
              value: typeof tag === "string" ? tag : tag.value,
              label: typeof tag === "string" ? tag : tag.label,
            }))}
            style={{ width: "100%" }}
            filterOption={(input, option) =>
              typeof option?.label === "string" &&
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
      )}
      {type === "location" && !viewOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Input
            disabled={disabled}
            type={type === "location" ? "text" : type}
            name={name}
            value={value}
            maxLength={maxLength}
            onChange={handleChange}
            readOnly={type === "location"}
            suffix={
              type === "location" && (
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    // Get current location value from form
                    const currentValue =
                      form?.getFieldValue?.(name) || value || "";
                    // Get location coordinates if stored
                    const locationData =
                      form?.getFieldValue?.(`${name}name`) || null;
                    const initialLocation = currentValue
                      ? {
                          place_name: currentValue,
                          center: locationData
                            ? [locationData.longitude, locationData.latitude]
                            : null,
                        }
                      : null;
                    locationClick(name, initialLocation);
                  }}
                  style={{
                    backgroundColor: "#1D9B8B",
                    border: "none",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                />
              )
            }
            onKeyDown={(e) => {
              if (
                onKeyDown &&
                !onKeyDown.test(e.key) &&
                e.key !== "Backspace"
              ) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
      )}
      {type === "fence" && !viewOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Input
            disabled={disabled || fenceLookupLoading}
            type={type === "fence" ? "text" : type}
            name={name}
            value={value}
            maxLength={maxLength}
            onChange={handleChange}
            readOnly={type === "fence"}
            suffix={
              type === "fence" && (
                <ButtonFilled
                  loading={fenceLookupLoading}
                  onClick={() => {
                    // prefer live form value, fall back to value prop
                    const fenceName =
                      (form &&
                        form.getFieldValue &&
                        form.getFieldValue(name)) ||
                      value ||
                      "";
                    if (isFenceEditMode && typeof onFenceEdit === "function") {
                      onFenceEdit(fenceName);
                    } else if (typeof onFenceCreate === "function") {
                      onFenceCreate(fenceName);
                    }
                  }}
                >
                  {isFenceEditMode ? "+ Edit" : "+ Create"}
                </ButtonFilled>
              )
            }
            onKeyDown={(e) => {
              if (
                onKeyDown &&
                !onKeyDown.test(e.key) &&
                e.key !== "Backspace"
              ) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
      )}
      {type === "phone" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          {/* <PhoneInput
            international
            defaultCountry={selectedCountry} // prop from parent
            country={selectedCountry}
            value={mobileValue}
            onChange={(value) => {
              handleChange({
                target: {
                  name,
                  value,
                },
              });
              form.setFieldsValue({ [name]: value });
            }}
            disabled={disabled}
          /> */}
        </Form.Item>
      )}

      {type === "file" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Upload
            name={name}
            showUploadList={true}
            beforeUpload={(file) => {
              return !form.getFieldValue(name);
            }}
            customRequest={({ file, onSuccess }) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);

              reader.onload = () => {
                const base64Data = reader.result.split(",")[1];
                onSuccess();
                handleSelectChange(
                  { url: base64Data, fileType: file.type },
                  name,
                );
              };
              reader.onerror = (error) => {};
            }}
            onChange={(info) => {
              if (info.file.status === "done") {
                form.setFieldsValue({ [name]: info.file });
              } else if (info.file.status === "error") {
              }
            }}
            disabled={form.getFieldValue(name)}
          >
            <div style={{ ...divStyle, cursor: "pointer" }}>
              {/* <ButtonOutlined>
                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                {""}
                Upload
              </ButtonOutlined> */}
            </div>
          </Upload>
        </Form.Item>
      )}

      {type === "dragger" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) {
              return e;
            }
            return e && e.fileList;
          }}
        >
          <Dragger
            // value={value}
            accept=".pdf"
            customRequest={({ file, onSuccess, onError }) => {
              if (file.type !== "application/pdf") {
                onError(new Error("Only PDF files are allowed!"));
                return;
              }
              const reader = new FileReader();
              reader.readAsDataURL(file);

              reader.onload = () => {
                const base64Data = reader.result.split(",")[1];
                // Pass both the file and base64Data to onSuccess
                const uniqueId = generateUniqueId();
                onSuccess({ file, base64Data, uniqueId });
              };

              reader.onerror = (error) => {
                message.error("only allow pdf file");
              };
            }}
            name="logo"
            listType="picture"
            style={{ width: "100%" }}
            onChange={(value) => {
              uploadFile(value);
              handleSelectChange(value.fileList, name);
              setRemainingFiles(5 - form.getFieldValue(name)?.length);
            }}
            maxCount={5}
            disabled={form.getFieldValue(name)?.length > 5}
          >
            <p className="ant-upload-drag-icon">
              {/* <Icon
                name="fileupload"
                style={{ width: "50px", height: "50px" }}
              /> */}
            </p>
            <p className="ant-upload-hint">Drag and drop file here</p>
            <p className="ant-upload-hint">{`Upload File (Remaining: ${remainingFiles}, size >100MB)`}</p>
          </Dragger>
        </Form.Item>
      )}

      {type === "textarea" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Input.TextArea
            disabled={disabled}
            placeholder={Placeholder}
            rows={row ? row : 3}
            name={name}
            onChange={handleChange}
            value={value}
            maxLength={maxLength}
            onKeyDown={(e) => {
              const value = onKeyDown?.test(e.key);
              if (!value && e.key !== "Backspace" && onKeyDown) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
      )}
      {type === "textareaMultiple" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
          autoSize={{ minRows: 1, maxRows: 6 }}
        >
          <Input.TextArea
            disabled={disabled}
            placeholder={Placeholder}
            rows={row ? row : 3}
            name={name}
            onChange={handleChange}
            value={value}
            maxLength={maxLength}
            onKeyDown={(e) => {
              const value = onKeyDown?.test(e.key);
              if (!value && e.key !== "Backspace" && onKeyDown) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
      )}
      {type === "textareaMultipleEmail" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <EmailTagInput
            value={value}
            onChange={(val) => handleChange({ target: { name, value: val } })}
            disabled={disabled}
            placeholder={Placeholder}
          />
        </Form.Item>
      )}

      {type === "password" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Input.Password
            disabled={disabled}
            placeholder={Placeholder}
            name={name}
            onChange={handleChange}
            value={value}
            onKeyDown={(e) => {
              const value = onKeyDown?.test(e.key);
              if (!value && e.key !== "Backspace" && onKeyDown) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
      )}
      {type === "url" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
          validateStatus={domainStatus}
        >
          {/* <Input
            placeholder={Placeholder}
            name={name}
            addonBefore={
              urlLoader ? (
                <LoadingOutlined spin />
              ) : domainStatus === "error" ? (
                // <ErrorIcon />
              ) : domainStatus === "success" ? (
                <CheckCircleIcon />
              ) : (
                <ErrorOutlineIcon />
              )
            }
            addonAfter={suffixUrl}
            onChange={handleChange}
            status={domainStatus}
            onKeyDown={(e) => {
              const value = onKeyDown?.test(e.key);
              if (!value && e.key !== "Backspace" && onKeyDown) {
                e.preventDefault();
              }
            }}
          /> */}
        </Form.Item>
      )}
      {type === "country" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
          validateStatus={domainStatus}
        >
          <Input
            placeholder={Placeholder}
            name={name}
            addonBefore={
              <Select
                defaultValue="Australia"
                // options={countryOptions}
                //note : need this
                // onChange={handleCountryChange}
              />
            }
            addonAfter={suffixUrl}
            onChange={handleChange}
            status={domainStatus}
            onKeyDown={(e) => {
              const value = onKeyDown?.test(e.key);
              if (!value && e.key !== "Backspace" && onKeyDown) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
      )}
      {type === "date" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <DatePicker
            showTime={showtime}
            style={pickerstyle}
            format={format}
            disabled={disabled}
            placeholder={Placeholder}
            picker={picker}
            inputReadOnly={true}
            onChange={(date, dateString) =>
              handleChange({ target: { value: date, name: name } })
            }
          />
        </Form.Item>
      )}
      {type === "daterange" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <RangePicker
            className="w-100"
            // style={pickerstyle}
            disabled={disabled}
            placeholder={Placeholder}
            inputReadOnly={true}
            defaultPickerValue={[dayjs(), dayjs()]}
            value={null}
            allowClear
            onChange={(date, dateString) =>
              handleChange({ target: { value: date, name: name } })
            }
            // value={
            //   value
            //     ? [
            //         moment(value[0], "YYYY-MM-DD"),
            //         moment(value[1], "YYYY-MM-DD"),
            //       ]
            //     : null
            // }
            format="DD-MM-YYYY"
          />
        </Form.Item>
      )}
      {type === "checkbox" && !readOnly && (
        <Form.Item
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          valuePropName="checked"
          rules={validationRules}
        >
          <Checkbox disabled={disabled} onChange={handleChange}>
            {link ? (
              <Link to={link} target="_blank" rel="noopener noreferrer">
                {label}
              </Link>
            ) : (
              label
            )}
          </Checkbox>
        </Form.Item>
      )}
      {type === "radio" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Radio.Group onChange={handleChange} value={value} name={name}>
            {options?.map((option, index) => (
              <Radio key={index} value={option}>
                {option}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      )}
      {type === "switch" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <Switch
            disabled={disabled}
            onChange={(e) => handleSelectChange(e, name)}
          />
          {/* <small>{value ? "Yes" : "No"}</small> */}
        </Form.Item>
        // <Form.Item
        //   name={name}
        //   valuePropName="checked"
        //   label={label}
        //   labelCol={labelCol}
        //   wrapperCol={wrapperCol}
        //   rules={validationRules}
        // >
        //   <Switch disabled={disabled} />
        // </Form.Item>
      )}

      {type === "button" && !readOnly && event === "submit" && (
        <div className={position}>
          <ButtonFilled
            htmlType="submit"
            disabled={disabled || loading || domainStatus === "error"}
            style={btnStyle}
          >
            {loading ? (
              <Spinner animation="border" size="sm" /> // Display a spinner when loading
            ) : (
              label
            )}
          </ButtonFilled>
        </div>
      )}

      {type === "button" && !readOnly && event === "click" && (
        <div className={position}>
          <p
            disabled={disabled}
            onClick={() => handleBack()}
            type="secondary"
            style={btnStyle}
          >
            {label}
          </p>
        </div>
      )}

      {type === "buttonNxt" && !readOnly && event === "submit" && (
        <div className={position}>
          {/* <ButtonFilled
            htmlType="submit"
            disabled={disabled || loading || domainStatus === "error"}
            style={btnStyle}
            onClick={handleNxt}
          >
            {loading ? (
              <Spinner animation="border" size="sm" /> // Display a spinner when loading
            ) : (
              label
            )}
          </ButtonFilled> */}
        </div>
      )}

      <div style={textEnd}>
        {/* {type === "combinebtnback" && !readOnly && event === "submit" && (
          <ButtonFilled
            htmlType="submit"
            disabled={disabled || loading || domainStatus === "error"}
            style={{ display: "inline-block" }}
            onClick={handleBack}
          >
            {loading ? (
              <Spinner animation="border" size="sm" /> // Display a spinner when loading
            ) : (
              label
            )}
          </ButtonFilled>
        )} */}

        {type === "combinebtnNxt" && !readOnly && event === "submit" && (
          <p
            htmlType="submit"
            disabled={disabled || loading || domainStatus === "error"}
            style={{ display: "inline-block" }}
            onClick={handleNxt}
          >
            {loading ? (
              <Spinner animation="border" size="sm" /> // Display a spinner when loading
            ) : (
              label
            )}
          </p>
        )}
      </div>

      {type === "buttongroup" && !readOnly && (
        <div className={position}>
          <Form.Item>
            <Button.Group>
              {buttons.map((button, index) => (
                <>
                  {button?.event === "submit" ? (
                    <p
                      key={index}
                      htmlType={button?.event}
                      disabled={button.disabled}
                      style={button.btnStyle}
                      onClick={button.onClick} // Add onClick handler if needed
                    >
                      {button.loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        button.label
                      )}
                    </p>
                  ) : (
                    <p
                      key={index}
                      disabled={button.disabled}
                      style={button.btnStyle}
                      onClick={button.onClick} // Add onClick handler if needed
                    >
                      {button.loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        button.label
                      )}
                    </p>
                  )}
                </>
              ))}
            </Button.Group>
          </Form.Item>
        </div>
      )}

      {type === "button" && !readOnly && event === "back" && (
        <div className={position}>
          <p
            disabled={disabled}
            onClick={() => handleClick()}
            type="secondary"
            style={btnStyle}
          >
            {label}
          </p>
        </div>
      )}

      {type === "div" && !readOnly && (
        <div style={divStyle} className={position}>
          {/* <a onClick={event === "click" ? () => handleForgotPassword() : ""}> */}
          {content}
          {/* </a> */}
        </div>
      )}

      {type === "component" && !readOnly && (
        <div className={position}>{content}</div>
      )}

      {(type === "" || type === undefined) && (
        <Form.Item label={label}></Form.Item>
      )}

      {type === "editor" && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <EditorConvertToHTML
            onChange={(val) => {
              form.setFieldsValue({ [name]: val });
            }}
            content={form.getFieldValue(name)}
          />
        </Form.Item>
      )}

      {type === "editorWithMentions" && !readOnly && (
        <Form.Item
          label={label}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name={name}
          rules={validationRules}
        >
          <EditorWithMentions
            value={value}
            onChange={(val) => {
              if (typeof handleChange === "function") {
                handleChange({ target: { value: val, name } });
              }
            }}
            suggestions={tagSuggestions}
          />
        </Form.Item>
      )}
      {type === "addfence" && (
        <Form.List className="mt-4" name={name} label={label}>
          {(fields, { add, remove }) => (
            <>
              <p className="mt-3 pb-4" style={labelsize}>
                {label}
              </p>
              {fields.map(({ key, name, ...restField }, index) => (
                <div key={key} style={{ marginBottom: "24px" }}>
                  {/* Consignee Select */}
                  <Form.Item
                    {...restField}
                    name={[name, index]}
                    rules={validationRules}
                    style={{ width: "100%", marginBottom: "12px" }}
                  >
                    <Select
                      placeholder={Placeholder}
                      options={options?.map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))}
                      disabled={disabled}
                      showSearch
                      value={value}
                      onChange={(val) =>
                        handleSelectChange(val, name, "list", index)
                      }
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                    />
                  </Form.Item>

                  {/* Custom Fields stacked vertically */}
                  {customFields?.map((nf) => (
                    <Form.Item
                      key={nf.name}
                      label={
                        <>
                          <span style={{ color: "red", marginRight: 4 }}>
                            {nf.validationRules?.[0]?.required ? "*" : ""}
                          </span>
                          {nf.label}
                        </>
                      }
                      style={{ width: "100%", marginBottom: "12px" }}
                    >
                      {nf.type === "select" || nf.type === "selectwithvalue" ? (
                        <Select
                          options={nf.options}
                          placeholder={nf.placeholder}
                          onChange={(val) =>
                            handleChange(
                              { target: { value: val } },
                              nf.name,
                              index,
                              true,
                            )
                          }
                          value={
                            initialValues?.customData?.[nf.name]?.[index] ||
                            undefined
                          }
                        />
                      ) : nf.type === "checkbox" ? (
                        <Checkbox
                          onChange={(e) =>
                            handleChange(
                              { target: { value: e.target.checked } },
                              nf.name,
                              index,
                              true,
                            )
                          }
                          checked={
                            initialValues?.customData?.[nf.name]?.[index] ||
                            false
                          }
                        />
                      ) : (
                        <Input
                          placeholder={nf.placeholder}
                          onChange={(e) =>
                            handleChange(
                              { target: { value: e.target.value } },
                              nf.name,
                              index,
                              true,
                            )
                          }
                          value={
                            initialValues?.customData?.[nf.name]?.[index] || ""
                          }
                        />
                      )}
                    </Form.Item>
                  ))}

                  {/* Remove Button */}
                  {index !== 0 && (
                    <MinusCircleOutlined
                      className="mb-4"
                      onClick={() => remove(name)}
                    />
                  )}
                </div>
              ))}

              <Form.Item>
                <ButtonFilled
                  className="mx-1 addButtonStyle"
                  style={{ width: "55%" }}
                  onClick={() => add()}
                >
                  <PlusOutlined /> Add
                </ButtonFilled>
              </Form.Item>
            </>
          )}
        </Form.List>
      )}
      {type === "addlist" && (
        <Form.List className="mt-4" name={name} label={label}>
          {(fields, { add, remove }) => (
            <>
              <p className="mt-3 pb-4" style={labelsize}>
                {label}
              </p>
              {fields.map(({ key, name: fieldName, ...restField }, index) => (
                <div key={key} style={{ marginBottom: "24px" }}>
                  {/* Consignee Select */}
                  <Form.Item
                    {...restField}
                    name={[fieldName]}
                    rules={validationRules}
                    style={{ width: "100%", marginBottom: "12px" }}
                  >
                    <Select
                      placeholder={Placeholder}
                      options={options?.map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))}
                      disabled={disabled}
                      showSearch
                      onChange={(val) =>
                        handleSelectChange(val, name, "list", index)
                      }
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                    />
                  </Form.Item>

                  {/* Custom Fields stacked vertically */}
                  {customFields?.map((nf) => (
                    <Form.Item
                      key={nf.name}
                      label={
                        <>
                          <span style={{ color: "red", marginRight: 4 }}>
                            {nf.validationRules?.[0]?.required ? "*" : ""}
                          </span>
                          {nf.label}
                        </>
                      }
                      style={{ width: "100%", marginBottom: "12px" }}
                    >
                      {nf.type === "select" || nf.type === "selectwithvalue" ? (
                        <Select
                          options={nf.options}
                          placeholder={nf.placeholder}
                          onChange={(val) =>
                            handleChange(
                              { target: { value: val } },
                              nf.name,
                              index,
                              true,
                            )
                          }
                          value={
                            initialValues?.customData?.[nf.name]?.[index] ||
                            undefined
                          }
                        />
                      ) : nf.type === "checkbox" ? (
                        <Checkbox
                          onChange={(e) =>
                            handleChange(
                              { target: { value: e.target.checked } },
                              nf.name,
                              index,
                              true,
                            )
                          }
                          checked={
                            initialValues?.customData?.[nf.name]?.[index] ||
                            false
                          }
                        />
                      ) : (
                        <Input
                          placeholder={nf.placeholder}
                          onChange={(e) =>
                            handleChange(
                              { target: { value: e.target.value } },
                              nf.name,
                              index,
                              true,
                            )
                          }
                          value={
                            initialValues?.customData?.[nf.name]?.[index] || ""
                          }
                        />
                      )}
                    </Form.Item>
                  ))}

                  {/* Remove Button */}
                  {index !== 0 && (
                    <MinusCircleOutlined
                      className="mb-4"
                      onClick={() => {
                        remove(fieldName);
                        handleSelectChange(null, name, "list-remove", index);
                      }}
                    />
                  )}
                </div>
              ))}

              <Form.Item>
                <ButtonFilled
                  htmlType="button"
                  className="mx-1 addButtonStyle"
                  style={{ width: "55%" }}
                  onClick={() => {
                    handleSelectChange(undefined, name, "list-add");
                    add();
                  }}
                >
                  <PlusOutlined /> Add
                </ButtonFilled>
              </Form.Item>
            </>
          )}
        </Form.List>
      )}
    </div>
  );
}

export default UIElement;
